<script setup lang="ts">
  import { computed, ref } from 'vue'
import { useUserStore } from '@/stores/user'
import { RouterLink, RouterView, useRoute } from 'vue-router'
import Logo from '@/assets/images/logo.svg?component'
import Avatar from '@/assets/images/avatar.svg?component'
import Search from '@/assets/images/search.svg?component'

const route = useRoute()
const userStore = useUserStore()
const protocolLinks = computed(() => userStore.getProtocolLinks)

const showSearch = ref(false)

const toggleSearch = () => {
  showSearch.value = !showSearch.value
}
</script>

<template>
  <div class="container">
    <div class="layout-container">
      <div class="navbar">
        <RouterLink to="/"><Logo /></RouterLink>
        <RouterLink to="/profile"><Avatar /></RouterLink>
      </div>
      <RouterLink class="search" to="/search" @click="toggleSearch">
        <Search />
        <div class="placeholder">搜索最新熱門好劇</div>
      </RouterLink>
      <div class="tabs">
        <RouterLink class="tab" :class="route.path === '/' && 'active'" to="/">首页</RouterLink>
        <RouterLink class="tab" :class="route.path === '/collection' && 'active'" to="/collection">收藏与记录</RouterLink>
      </div>
    </div>
    <RouterView />
    <div class="footer">
      <div class="text"><a :href="protocolLinks.user || undefined" target="_blank" rel="noopener noreferrer">用戶協議</a> ｜ <a :href="protocolLinks.privacy || undefined" target="_blank" rel="noopener noreferrer">隱私政策</a></div>
      <div class="copyright">Copyright © 2025 StoryRush All Rights Reserved</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.container {
  height: 100vh;
  background-color: #0C0F08;
  font-family: PingFang SC, PingFang SC;
}
.layout-container {
  margin-bottom: 16px;
  padding: 0 16px;
}
.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 0;
  a {
    display: flex;
    align-items: center;
  }
}
.search {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
  padding: 12px;
  border-radius: 12px;
  background-color: #1E1D1D;
  .placeholder {
    font-size: 15px;
    color: #636363;
    line-height: 12px;
  }
}
.tabs {
  display: flex;
  gap: 24px;
  align-items: baseline;
  margin-top: 17px;
  .tab {
    font-size: 16px;
    color: #B7B7B7;
    line-height: 22px;
    text-decoration: none;
    outline: none;
  }
  .tab.active {
    color: #FFFFFF;
    font-size: 20px;
    font-weight: 500;
    line-height: 28px;
  }
}
.footer {
  padding: 20px 16px 30px;
  .text {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    color: #FFFFFF;
    line-height: 12px;
  }
  a {
    font-size: 10px;
    color: #936BFF;
    line-height: 12px;
    text-decoration: none;
  }
  .copyright {
    margin-top: 12px;
    font-size: 10px;
    color: #FFFFFF;
    line-height: 12px;
    text-align: center;
  }
}
</style>
